import { pushProductSelectorEvent } from "./analytics";

/**
 * Yes/No feedback vote (per-selector localStorage lock).
 *
 * @param {object} cfg ignitedProductSelector
 */
export function initProductSelectorFeedback(cfg) {
  const root = document.getElementById("product-selector-feedback");

  if (!root || !cfg || !cfg.ajaxUrl || !cfg.voteAction || !cfg.nonce) {
    return;
  }

  const termId = cfg.termId || Number(root.getAttribute("data-term-id") || 0);

  if (!termId) {
    return;
  }

  const storageKey = "selector-vote-" + String(termId);
  const buttons = root.querySelectorAll("[data-ps-vote]");

  function applyVotedState(vote) {
    buttons.forEach(function(btn) {
      const btnVote = btn.getAttribute("data-ps-vote");

      btn.disabled = true;
      if (btnVote === vote) {
        btn.classList.add("is-voted");
      } else {
        btn.classList.remove("is-voted");
      }
    });
  }

  const existing = localStorage.getItem(storageKey);

  if (existing === "yes" || existing === "no") {
    applyVotedState(existing);

    return;
  }

  buttons.forEach(function(btn) {
    btn.addEventListener("click", function() {
      const vote = btn.getAttribute("data-ps-vote");

      if (vote !== "yes" && vote !== "no") {
        return;
      }

      if (localStorage.getItem(storageKey)) {
        return;
      }

      localStorage.setItem(storageKey, vote);
      applyVotedState(vote);
      pushProductSelectorEvent(cfg, "product_selector_feedback", {
        vote: vote
      });

      const body = new URLSearchParams();

      body.set("action", cfg.voteAction);
      body.set("nonce", cfg.nonce);
      // eslint-disable-next-line camelcase
      body.set("term_id", String(termId));
      body.set("vote", vote);

      fetch(cfg.ajaxUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        },
        body: body.toString()
      }).catch(function() {
        // Keep UI locked to avoid double-submit retries.
      });
    });
  });
}
